import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ms-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
